import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

const PageHeader = ({ crumbs = [], title, chips, actions, tabs, leading }) => (
    <Box
        sx={{
            backgroundColor: 'var(--surface)',
            borderBottom: '1px solid var(--line)',
            px: 2.5,
            pt: 1.1,
            flex: 'none',
        }}
    >
        {crumbs.length > 0 && (
            <Box
                sx={{
                    fontSize: 11.5,
                    color: 'var(--muted)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    mb: 0.25,
                }}
            >
                {crumbs.map((crumb, index) => (
                    <React.Fragment key={`${crumb.label}-${index}`}>
                        {index > 0 && <Box component="span" sx={{ color: 'var(--muted-2)', fontStyle: 'normal' }}>/</Box>}
                        {crumb.to
                            ? <Box component={Link} to={crumb.to} sx={{ color: 'var(--muted)', textDecoration: 'none', '&:hover': { color: 'var(--accent-ink)', textDecoration: 'underline' } }}>{crumb.label}</Box>
                            : <Box component="span">{crumb.label}</Box>
                        }
                    </React.Fragment>
                ))}
            </Box>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: tabs ? 1.25 : 1.25 }}>
            {leading}
            {title && (
                <Box component="h1" sx={{ m: 0, fontSize: 19, fontWeight: 600, letterSpacing: '-0.01em', color: 'var(--ink)' }}>
                    {title}
                </Box>
            )}
            {chips}
            {actions && (
                <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                    {actions}
                </Box>
            )}
        </Box>
        {tabs}
    </Box>
);

export default PageHeader;
